import { DateTime } from 'luxon';

import { useUid } from '@rygen/rygen-ui/composables';
import {
  CorsairDocumentType,
  DocumentParentEntity,
  IRelatedDocument,
  Module,
} from '@rygen/rygen-ui/model';
import { loadLuxonDateTime } from '@rygen/rygen-ui/util';

import { DocumentSource } from './DocumentSource';

export class RelatedDocument implements IRelatedDocument {
  id?: number;
  parentId?: number;
  parentDisplayId?: string;
  parentEntity?: DocumentParentEntity;
  types: CorsairDocumentType[] = [];
  documentName?: string;
  fileName?: string;
  contentType?: string;
  signedUrl?: string;
  createdBy?: string;
  createdDate?: DateTime;
  sourceModule?: Module;
  source?: DocumentSource;
  uid: string;

  constructor(opts?: Partial<RelatedDocument>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.parentId != null) {
      this.parentId = opts.parentId;
    }
    if (opts?.parentDisplayId != null) {
      this.parentDisplayId = opts.parentDisplayId;
    }
    if (typeof opts?.parentEntity === 'string') {
      this.parentEntity = DocumentParentEntity[opts.parentEntity];
    } else if (opts?.parentEntity != null) {
      this.parentEntity = opts.parentEntity;
    }
    if (opts?.types != null) {
      this.types = opts.types.map((val) => {
        return typeof val === 'string' ? CorsairDocumentType[val] : val;
      });
    }
    if (opts?.documentName != null) {
      this.documentName = opts.documentName;
    }
    if (opts?.fileName != null) {
      this.fileName = opts.fileName;
    }
    if (opts?.contentType != null) {
      this.contentType = opts.contentType;
    }
    if (opts?.signedUrl != null) {
      this.signedUrl = opts.signedUrl;
    }
    if (opts?.createdBy != null) {
      this.createdBy = opts.createdBy;
    }
    if (typeof opts?.sourceModule === 'string') {
      this.sourceModule = Module[opts.sourceModule];
    } else if (opts?.sourceModule != null) {
      this.sourceModule = opts.sourceModule;
    }
    if (typeof opts?.source === 'string') {
      this.source = DocumentSource[opts.source];
    } else if (opts?.source != null) {
      this.source = opts.source;
    }
    this.createdDate = loadLuxonDateTime(opts?.createdDate);
    if (opts?.uid != null) {
      this.uid = opts.uid;
    } else {
      this.uid = useUid('RelatedDocument').uid;
    }
  }
}
